import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

import ArrowRight from '../../../assets/icons/arrow-right.svg?react'
import CloseIcon from '../../../assets/icons/close.svg?react'
import SeeAllLink from '../form/SeeAllLink'

export interface Props {
  children: React.ReactNode | React.ReactNode[]
  title: string
  link?: { to: string, label: string },
  showBackLink?: boolean
  showCloseIcon?: boolean // used in full screen sections
  color?: string
  seeAllReplace?: boolean
  goBackLink?: string
}
const PageSection: React.FC<Props> = ({ children, title, link, showBackLink, showCloseIcon, color = 'deep-green', seeAllReplace, goBackLink }) => {
  const navigate = useNavigate()

  const linkClass = 'text-sm flex items-center gap-x-1'
  return (
    <div className='py-5 sm:pt-10'>
      <div className='flex justify-between items-center mb-3'>
        <h2 className={`text-${color}`}>{title}</h2>
        <div className='gap-x-6 flex'>
          {showBackLink && <Link className={`${linkClass} text-black `} to='' onClick={() => navigate(-1)}><ArrowRight className='w-3 rotate-180 fill-deep-green' />Volver</Link>}
          {link && <SeeAllLink label={link.label} linkTo={link.to} replace={seeAllReplace} />}
          {showCloseIcon && <button onClick={() => goBackLink ? navigate(goBackLink) : navigate(-1)}><CloseIcon className={`stroke-${color} w-10 h-10`} /></button>}
        </div>
      </div>
      {children}
    </div>
  )
}

export default PageSection
